import { createContext, useReducer, ReactNode } from 'react';
import { Action, InitialState, ReducerLanguage } from './ReducerLanguage';
import { Language } from '../labels/language.labels';
import { Texts } from '../labels/language.texts';

const codeToName: Record<string, string> = {
  en: 'english', es: 'spanish', fr: 'french', it: 'italian', de: 'german',
}

const init = () => {
  const hasData = localStorage.getItem('language')
  if (!hasData) return InitialState

  const langMap = Texts.lang as Record<string, Language>

  // hasData is normally a key name ("french") — direct lookup
  if (langMap[hasData]) {
    return { code: langMap[hasData].code, labels: langMap[hasData].labels }
  }

  // Tolerate a stored code ("fr" / "FR") from older writes
  const name = codeToName[hasData.toLowerCase()]
  if (name && langMap[name]) {
    return { code: langMap[name].code, labels: langMap[name].labels }
  }

  return InitialState
}

type ContextDispatch = (action: Action) => void
type Context = { lang: Language }
type Props = { children: ReactNode }

export const CreatedContextDispatch = createContext<ContextDispatch>(() => { })

export const CreatedContextLanguage = createContext<Context>({ lang : InitialState })

export const ContextLanguage = ({ children } : Props) => {
  const [lang, dispatch] = useReducer(ReducerLanguage, InitialState, init)

  return (
    <CreatedContextDispatch.Provider value={dispatch}>
      <CreatedContextLanguage.Provider value={{lang}}>
        {children}
      </CreatedContextLanguage.Provider>
    </CreatedContextDispatch.Provider>
  )
}